module.exports = __webpack_public_path__ + "static/media/mai68.b6dce77c.jpg";